import { Modal } from "react-bootstrap";
import { DismissDraftDocumentModalProps } from "../upload-document/UploadDocument.types";

export function DismissUploadDocumentSessionModal({
  show,
  onCancel,
  onDismiss,
}: DismissDraftDocumentModalProps) {
  return (
    <Modal show={show} animation onHide={onCancel}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          Dismiss previous upload(s)
        </h5>
        <div onClick={onCancel}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to dismiss previous upload(s)? This action is
        irreversible.
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger" onClick={onDismiss}>
          Dismiss
        </button>
      </Modal.Footer>
    </Modal>
  );
}
